import { render, staticRenderFns } from "./MediaColumnSide.vue?vue&type=template&id=4b1929f1&scoped=true&"
import script from "./MediaColumnSide.vue?vue&type=script&lang=js&"
export * from "./MediaColumnSide.vue?vue&type=script&lang=js&"
import style0 from "./MediaColumnSide.vue?vue&type=style&index=0&id=4b1929f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1929f1",
  null
  
)

export default component.exports